module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu column--single"
  }, [_c('div', {
    staticClass: "menu__section_title"
  }, [_vm._v("The Basics")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "origins-of-type"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-origins-of-type.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n            Origins of Type\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "hangul-blocks"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-hangul-blocks.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n            Hangul Blocks\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "letter-form-anatomy"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-letter-form-anatomy.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n            Letter-form Anatomy\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "type-categories"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-type-categories.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n            Type Categories\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu__section_title"
  }, [_vm._v("Connotative")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "italics-dashes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-italics-dashes.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n          Italics, -, –, —, and ˜\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "emoticons-text"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-emoticons-text.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n          Emoticons & Text\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "expressive-type"
    },
    nativeOn: {
      "click": function($event) {
        _vm.select($event)
      }
    }
  }, [_c('div', {
    staticClass: "menu__item"
  }, [_c('div', {
    staticClass: "menu__left"
  }, [_c('div', {
    staticClass: "menu__icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/menu/ic-expressive-type.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu__title"
  }, [_vm._v("\n          Expressive Type\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu__arrow"
  }, [_vm._v("\n        →\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db5a473","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMenu.vue
// module id = 149
// module chunks = 0